import {z} from "zod/v4";
import {TieredOrActive} from "./tieredOrActive.tsx";
import {SortOrder} from "../rpc/webrpc-client.gen.ts";

export const DispatchOverviewSettings = z.object({
    order: TieredOrActive,
    sortOrder: SortOrder,
});
export type DispatchOverviewSettings = z.infer<typeof DispatchOverviewSettings>;
export const defaultDispatchOverviewSettings: DispatchOverviewSettings = {
    order: TieredOrActive.enum.active,
    sortOrder: SortOrder.enum.DESC,
};

export function validateDispatchOverviewSettings(raw: Record<string, unknown>): DispatchOverviewSettings {
    const zprv = DispatchOverviewSettings.safeParse(raw);
    const rv = zprv.success ? zprv.data : defaultDispatchOverviewSettings;
    return rv;
}

